<div (click)="maininput.click($event); $event.stopPropagation()" [ngClass]="menu.disabled ? 'disable' : menu.styleClass || ''">
  <p-menu #menupop [popup]="true" [model]="menu.items" appendTo="body"></p-menu>
  <h1 (click)="open($event); $event.stopPropagation()" #maininput>{{ menu.label }}</h1>
  <i [ngClass]="menu.icon"></i>
</div>
